export default "__VITE_ASSET__CW$8ZAxK__"